/*
 * @Desc: 文件描述
 * @Author: jiayi zhu
 * @Date: 2020-07-06 11:47:34
 * @LastEditors: jiayi zhu
 */
export default {
  getQyWechatCode(data) {
    return this.http('Longan', 'get', 'api/v1/wework/agents/jsapi_config', data)
      .then((res) => {
        return res;
      });
  },
  getUserMes(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/customer_detail', data)
      .then((res) => {
        return res;
      });
  },
  getUserOrderMes(data) {
    return this.http('Longan', 'get', '/api/v1/users/one_order_list', data)
      .then((res) => {
        return res;
      });
  },
  getUserMemberMes(data) {
    return this.http('Longan', 'get', '/api/v1/users/member_info', data)
      .then((res) => {
        return res;
      });
  },
  getUserInfo(data) {
    return this.http('Longan', 'get', '/api/v1/wework/agents/userinfo', data)
      .then((res) => {
        return res;
      });
  },
  addUserKey(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/bind_user_key', data)
      .then((res) => {
        return res;
      });
  },
  clearUserKey(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/clear_user_key', data)
      .then((res) => {
        return res;
      });
  },
  getCouponList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/ice_coupons', data)
      .then((res) => {
        return res;
      });
  },
  getWechatGoodList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/sale_goods', data)
      .then((res) => {
        return res;
      });
  },
  getUserTags(data) {
    return this.http('Longan', 'get', '/api/v1/wework/ice_tags', data)
      .then((res) => {
        return res;
      });
  },
  goAddUserTags(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/add_tags', data)
      .then((res) => {
        return res;
      });
  },
  deleteUserTag(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/remove_tags', data)
      .then((res) => {
        return res;
      });
  },
  postCoupon(data) {
    return this.http('Longan', 'post', '/api/v1/wework/ice_coupons/send_coupon', data)
      .then((res) => {
        return res;
      });
  },
  getIceBots(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/ice_bots', data)
      .then((res) => {
        return res;
      });
  },
  updateWechatUserMes(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/update_profile', data)
      .then((res) => {
        return res;
      });
  },
  getCustomList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/brief_index', data)
      .then((res) => {
        return res;
      });
  },
  getFollowList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/follow_ups', data)
      .then((res) => {
        return res;
      });
  },
  postFollowMes(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/create_follow_up', data)
      .then((res) => {
        return res;
      });
  },
  postWechatAuthCode(data) {
    return this.http('Longan', 'post', '/api/v1/questionnaires/auth_code', data)
      .then((res) => {
        return res;
      });
  },
  postWechatAuth(data) {
    return this.http('Bee', 'post', '/go_api/v2/questionnaires/auth', data)
      .then((res) => {
        return res;
      });
  },
  postQuestionnaire(data) {
    return this.http('Longan', 'post', '/api/v1/questionnaires/commit', data)
      .then((res) => {
        return res;
      });
  },
  getBehaviorList(data) {
    return this.http('DataInterface', 'get', 'v1/external-customers/get-customer-by-behavior', data)
      .then((res) => {
        return res;
      });
  },
  getBehavior(data) {
    return this.http('DataInterface', 'get', 'v1/external-customers/get-behavior-list', data)
      .then((res) => {
        return res;
      });
  },
  getMomentList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/moments', data)
      .then((res) => {
        return res;
      });
  },
  getMomentMedia(data) {
    return this.http('Longan', 'post', '/api/v1/wework/moments/get_media', data)
      .then((res) => {
        return res;
      });
  },
  getMomentCreatorMes(data) {
    return this.http('Longan', 'get', '/api/v1/wework/moments/creator_info', data)
      .then((res) => {
        return res;
      });
  },
  getWaitFollowList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/wait_follow_list', data)
      .then((res) => {
        return res;
      });
  },
  getWechatCart(data) {
    return this.http('Longan', 'get', '/api/v1/users/one_cart_items', data)
      .then((res) => {
        return res;
      });
  },
  changeFollowState(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/complete_follow_up', data)
      .then((res) => {
        return res;
      });
  },
  getVisitList(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/revisits', data)
      .then((res) => {
        return res;
      });
  },
  createVisitRecord(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/create_revisit', data)
      .then((res) => {
        return res;
      });
  },
  getWechatHealthSurvey(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/health_profile', data)
      .then((res) => {
        return res;
      });
  },
  saveWechatHealthSurvey(data) {
    return this.http('Longan', 'post', '/api/v1/wework/external_customers/update_health_profile', data)
      .then((res) => {
        return res;
      });
  },
  getWechatHealthSurveySummary(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/health_summary', data)
      .then((res) => {
        return res;
      });
  },
  getWechatOrder(data) {
    return this.http('Longan', 'get', '/api/v1/wework/external_customers/all_orders', data)
      .then((res) => {
        return res;
      });
  },
  addEkaOrder(data) {
    return this.http('DataInterface', 'post', 'v1/external-customers/bind-order', data)
      .then((res) => {
        return res;
      });
  },
  getCustomListNew(data) {
    return this.http('DataInterface', 'get', 'v1/external-customers/get-uk-and-order-no-info', data)
      .then((res) => {
        return res;
      });
  },
  sendGroupMessage(data) {
    return this.http('DataInterface', 'post', 'v1/external-customers/send-group-message', data)
      .then((res) => {
        return res;
      });
  }
};
